import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollContainer"]

  highlight(event) {
    const parentId = event.currentTarget.dataset.parentQuestionId
    if (!parentId) return

    // 左パネルの選択状態をリセット
    this.element.querySelectorAll("[data-parent-question-id]").forEach((el) => {
      el.classList.remove("ring-2", "ring-indigo-400", "bg-indigo-50")
    })
    event.currentTarget.classList.add("ring-2", "ring-indigo-400", "bg-indigo-50")

    // 右パネル行のハイライトをリセット
    const rows = this.element.querySelectorAll("tr[data-parent-id]")
    rows.forEach((r) => r.classList.remove("bg-indigo-100"))

    // 対象の行をハイライト
    const targetRows = this.element.querySelectorAll(`tr[data-parent-id="${parentId}"]`)
    targetRows.forEach((r) => r.classList.add("bg-indigo-100"))

    if (targetRows.length === 0) return

    // 右パネルのスクロールコンテナ内で先頭に表示（sticky thead の高さ分オフセット）
    // ただし対象行がすでに可視範囲に入っている場合はスクロールしない
    const container = targetRows[0].closest(".overflow-auto")
    if (!container) return

    const thead = container.querySelector("thead")
    const theadHeight = thead ? thead.offsetHeight : 0
    const containerRect = container.getBoundingClientRect()
    const firstRect = targetRows[0].getBoundingClientRect()
    const lastRect = targetRows[targetRows.length - 1].getBoundingClientRect()

    const visibleTop = containerRect.top + theadHeight
    const visibleBottom = containerRect.bottom
    const isFullyVisible = firstRect.top >= visibleTop && lastRect.bottom <= visibleBottom
    if (isFullyVisible) return

    const targetTop = container.scrollTop + firstRect.top - containerRect.top - theadHeight
    this.smoothScrollTo(container, targetTop, 600)
  }

  // ヌルっとしたスクロール（easeInOutCubic）
  smoothScrollTo(element, to, duration) {
    if (this.scrollAnimationId) cancelAnimationFrame(this.scrollAnimationId)
    const start = element.scrollTop
    const change = to - start
    const startTime = performance.now()

    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)

    const animate = (now) => {
      const elapsed = now - startTime
      const progress = Math.min(elapsed / duration, 1)
      element.scrollTop = start + change * ease(progress)
      if (progress < 1) {
        this.scrollAnimationId = requestAnimationFrame(animate)
      } else {
        this.scrollAnimationId = null
      }
    }
    this.scrollAnimationId = requestAnimationFrame(animate)
  }
}
